import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/Index'

Vue.use(Router)

export default new Router({
    // base:'/zhyxypt_test/website/',
    base:'/gwgp/',  //生产
    // base:'/zhyxypt_test/gwgp_test/', //测试
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
    ]
})
